import AppLayout from "../components/layout/AppLayout";
import ChatComponent from "../components/ai/ChatComponent";

export default function AI() {
  return (
    <AppLayout hideDateFilter>
      <ChatComponent />
    </AppLayout>
  );
}
